import { useEffect, useState } from 'react';
import { useQuickBasketContext } from '../utils/QuickBasketContext';

type ReturnValue = {
  userInputQty: number;
  minBasketItems: number;
  maxBasketItems: number;
  handleUserInput: (n: number) => void;
};

export const useUpdateQuantity = (id: string, qty: number): ReturnValue => {
  const [interacting, setInteracting] = useState(false);
  const [userInputQty, setUserInputQty] = useState(qty);

  const { isUpdatingBasket, minBasketItems, maxBasketItems, handleSetBasketItemQuantity } =
    useQuickBasketContext();

  const handleUserInput = (n: number) => {
    setInteracting(true);
    setUserInputQty((prev) => {
      if (prev + n < minBasketItems || prev + n > maxBasketItems) return prev;
      return prev + n;
    });
  };

  useEffect(() => {
    if (qty === userInputQty || interacting || isUpdatingBasket) return;
    handleSetBasketItemQuantity(id, userInputQty);
  }, [id, qty, userInputQty, interacting, isUpdatingBasket]);

  useEffect(() => {
    if (!interacting && !isUpdatingBasket) return;

    const t = setTimeout(() => {
      setInteracting(false);
    }, 100);

    return () => clearTimeout(t);
  }, [interacting]);

  return { userInputQty, minBasketItems, maxBasketItems, handleUserInput };
};
